import { getWebSocketHost } from "src/utils/activeApiEndpoint";

import { SyncFollowStreamManager } from "./syncFollowStreamManager";

export class BilgeStreamManager extends SyncFollowStreamManager {
  init() {
    this.connectSocket(
      () => `wss://${getWebSocketHost()}/stream/v1/organization`
    );
  }
}
